import React from 'react';
import { FileText } from 'lucide-react';
import { Link } from 'react-router-dom';

export function LandingFooter() {
  return (
    <footer className="py-6 sm:py-8 border-t border-slate-200/50 dark:border-white/5 bg-white/50 dark:bg-slate-950/50 backdrop-blur-lg relative z-10">
      <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row justify-between items-center gap-6 text-sm text-slate-500 dark:text-slate-400 font-medium">
        <div className="flex flex-col sm:flex-row items-center gap-2 sm:gap-2.5">
          <div className="flex items-center gap-2.5 sm:mb-0 mb-1">
            <div className="bg-emerald-600 text-white dark:bg-emerald-500 dark:text-emerald-950 p-1 rounded-md dark:shadow-sm group-hover:scale-105 transition-transform">
              <FileText className="w-4 h-4" strokeWidth={2.5} />
            </div>
            <span className="font-bold text-base tracking-tight text-emerald-800 dark:text-emerald-400">Resume<span className="text-emerald-600/70 dark:text-emerald-300/70 font-medium">Pro</span></span>
          </div>
          <span className="hidden sm:inline opacity-30 mx-2">|</span>
          <div className="flex flex-col items-center sm:items-start">
            <p className="text-center sm:text-left">© {new Date().getFullYear()} All rights reserved.</p>
            <p className="text-[10px] opacity-70 mt-1 max-w-[280px] sm:max-w-none text-center sm:text-left leading-tight">
              This site is protected by reCAPTCHA and the Google <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className="hover:underline">Privacy Policy</a> and <a href="https://policies.google.com/terms" target="_blank" rel="noopener noreferrer" className="hover:underline">Terms of Service</a> apply.
            </p>
          </div>
        </div>
        <div className="flex flex-wrap justify-center gap-6">
           <Link to="/privacy" className="hover:text-emerald-600 dark:hover:text-emerald-400 transition-colors">Privacy Policy</Link>
           <Link to="/terms" className="hover:text-emerald-600 dark:hover:text-emerald-400 transition-colors">Terms of Service</Link>
        </div>
      </div>
    </footer>
  );
}
